import React from "react";
import { Avatar, Dropdown, Layout, Menu, Space, Image, Tooltip, Popconfirm, Button } from 'antd';
import { MainMenu } from "./mainmenu";
import { MenuUnfoldOutlined, MenuFoldOutlined, UserOutlined, KeyOutlined, DownOutlined, UserDeleteOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt, faUserAlt } from '@fortawesome/free-solid-svg-icons';
import 'antd/dist/antd.css';
import { Link, Redirect, Route, RouteComponentProps, Switch } from "react-router-dom";
import { ICallOptions } from "../components/infrastructure/models";
import * as AllComponents from './components';
import { BaseComponent, IBaseProps, IBaseStates } from "../components/infrastructure/baseComponent";
import CustomSpinner from "../components/infrastructure/customSpinner";
import AppContext, { AppContextProps } from "../components/infrastructure/appContext";
import { ErrorBoundary } from "./errorBoundary";
import { Core } from "../components/infrastructure/core";
import BackTopButton from "../components/backTopButton";
import UserPanel from "./userPanel";

const { Header, Content, Footer } = Layout;

interface NsLayoutState extends IBaseStates {
    drawerCollapsed: boolean;
}

interface NsLayoutProps extends IBaseProps {
    children?: React.ReactNode;
}

export class MainLayout extends BaseComponent<NsLayoutProps, NsLayoutState> {
    static displayName = Layout.name;
    static contextType = AppContext;
    mounted: boolean = false;
    logo?: HTMLImageElement | null;
    constructor(props: NsLayoutProps) {
        super(props)
        this.state = {
            loading: true,
            isAuthorized: true,
            windowSize: window.innerWidth <= 765 ? 1 : 2,
            drawerCollapsed: true
        };
    }
    toggle = () => {
        const { sidebarCollapsed, setSidebarCollapsed } = this.context as AppContextProps;
        setSidebarCollapsed(!sidebarCollapsed);
    };
    componentDidMount() {
        this.mounted = true;
        super.componentDidMount();
        this.getMenu();
    }
    componentDidUpdate() {
        const { sidebarCollapsed } = this.context as AppContextProps;
        if (this.logo) {
            if (sidebarCollapsed)
                this.logo.classList.add("fadeOut");
            else
                this.logo.classList.add("fadeIn");
        }
    }
    componentWillUnmount() {
        this.mounted = false;
        super.componentWillUnmount();
    }
    getMenu = async () => {
        const { setInfo } = this.context as AppContextProps;
        let opt: ICallOptions = {
            url: 'home/getmenu',
            onSuccess: (result) => {
                if (result.ValidationState.Successful) {
                    const { MenuItems, UserInfo } = (result as any).Data;
                    setInfo(MenuItems, UserInfo);
                }
            },
            onComplete: () => {
                const { getUserInfo } = this.context as AppContextProps;
                if (!getUserInfo || !getUserInfo())
                    this.setState({ isAuthorized: false });
            }
        };

        await this.callApi(opt);
    }
    removeAccount = async () => {
        let opt: ICallOptions = {
            url: 'user/removeaccount',
            onSuccess: (result) => {
                if (result.ValidationState.Successful) {
                    window.location.replace("/");
                }
            }
        };

        await this.callApi(opt);
    }
    virtualRender() {
        if (!this.mounted)
            return <></>;

        if (this.state.loading)
            return (<div className="center" style={{ minHeight: "100vh" }}><CustomSpinner /></div>);

        const { getMenuItems, getUserInfo } = this.context as AppContextProps;
        const menuItems = getMenuItems();
        const { userFullName, extraVariables, profilePicturePath } = getUserInfo()!;

        const isPolicyholder = extraVariables["PolicyholderId"];
        //const isPolicyholder = extraVariables["IsPolicyholder"];

        const menu = (
            <Menu style={{ width: "auto" }}>
                <Menu.Item key="username">
                    <div style={{ marginLeft: 10, fontWeight: "bold" }}>
                        {userFullName}
                    </div>
                </Menu.Item>
                <Menu.Item key="profile" icon={<UserOutlined />}>
                    <Link to={{ pathname: '/profile' }}>پروفایل</Link>
                </Menu.Item>
                {!!isPolicyholder &&
                    <Menu.Item key="resetpassword" icon={<KeyOutlined />}>
                        <Link to={{ pathname: '/resetpassword' }}>تغییر کلمه عبور</Link>
                    </Menu.Item>
                }
                {!!isPolicyholder &&
                    <Popconfirm
                        title="آیا از حذف حساب خود اطمینان دارید؟"
                        onConfirm={this.removeAccount}
                    >
                        <Menu.Item key="removeaccount" style={{ padding: 0 }}>
                            <Button style={{ margin: 0, padding: '4px 10px', border: 'none' }} icon={<UserDeleteOutlined />}>حذف حساب کاربری</Button>
                        </Menu.Item>
                    </Popconfirm>
                }
            </Menu>
        );

        const { sidebarCollapsed, blockLayout, blockTitle } = this.context as AppContextProps;

        let footerStyle: any = { textAlign: 'center', backgroundColor: 'rgb(217 232 233)', zIndex: 1000 };
        if (!Core.isTestEnvironment)
            footerStyle = { ...footerStyle, padding: 0 };

        return (
            <Layout className="mainlayout">
                <Header className="box site-layout-background col" style={{
                    padding: 0,
                    width: "100%",
                    zIndex: 1000,
                    background: 'rgb(205 215 245)'
                }}>
                    <div className="row" style={{ margin: 0 }}>
                        <div style={{ padding: 0, width: 230 }}>
                            <img alt="" ref={node => this.logo = node} className={sidebarCollapsed ? "logo1" : "logo"} src={sidebarCollapsed ? "./logo.png" : "./logoFull.png"} />
                            {React.createElement(sidebarCollapsed ? MenuFoldOutlined : MenuUnfoldOutlined, {
                                className: 'trigger',
                                onClick: this.toggle,
                                style: {}
                            })}
                        </div>
                        <div style={{ width: "calc(100% - 230px)" }}>
                            <div style={{ float: "left" }}>
                                <Space>
                                    <UserPanel />
                                    <Dropdown overlay={menu} arrow={true} trigger={["click"]} >
                                        <Space className="userinfo">
                                            <DownOutlined style={{ color: "grey" }} />
                                            {profilePicturePath
                                                ? <Avatar src={<Image src={profilePicturePath} style={{ height: 48 }} />} size={48} />
                                                : <Avatar icon={<FontAwesomeIcon icon={faUserAlt} style={{ verticalAlign: 'text-top', fontSize: 24 }} />} size={48} />
                                            }
                                        </Space>
                                    </Dropdown>
                                    <Tooltip title={"خروج"} >
                                        <Link to={{ pathname: '/logout' }} style={{ position: 'relative', top: 6 }}>
                                            <FontAwesomeIcon className="fa-signout" icon={faSignOutAlt} style={{ fontSize: 20 }} transform={{ flipX: true }} />
                                        </Link>
                                    </Tooltip>
                                </Space>
                            </div>
                        </div>
                    </div>
                </Header>
                <Layout className="site-layout">
                    {this.state.loading ? <CustomSpinner /> :
                        <MainMenu components={menuItems}></MainMenu>
                    }
                    <Content style={{
                        paddingBottom: 10,
                        position: "relative"
                    }}>
                        <div id="content-container"
                            className="custom-scroll site-layout-background"
                            style={{
                                padding: '0px 10px',
                                minHeight: 280,
                                paddingBottom: 20
                            }}
                        >
                            <Switch>
                                <Route exact path='/errorpage' component={AllComponents.ErrorPage} />
                                <Route exact path="/" render={() =>
                                    <ErrorBoundary>
                                        <AllComponents.Home />
                                    </ErrorBoundary>
                                } />
                                <Route exact path="/profile" render={() =>
                                    <ErrorBoundary>
                                        <AllComponents.Profile />
                                    </ErrorBoundary>
                                } />
                                <Route exact path="/resetpassword" render={() =>
                                    <ErrorBoundary>
                                        <AllComponents.ResetPassword />
                                    </ErrorBoundary>
                                } />
                                <Route exact path="/logout" render={() =>
                                    <ErrorBoundary>
                                        <AllComponents.LogOut />
                                    </ErrorBoundary>
                                } />
                                {menuItems.filter((c, index) => c.Item && !menuItems.filter((a, i) => i < index && a.Item?.split('?')[0] === c.Item?.split('?')[0]).length)
                                    .map(component => {
                                        const componentName = component.Item!.split('?')[0];
                                        const Component = (AllComponents as any)[componentName];
                                        return Component && (
                                            <Route
                                                path={"/" + componentName}
                                                key={componentName}
                                                render={() =>
                                                    <ErrorBoundary>
                                                        <Component />
                                                    </ErrorBoundary>
                                                }
                                            />)
                                    })}
                                <Route path="/refresh" render={(props: RouteComponentProps) => {
                                    const { search } = props.location;
                                    const currentPath = decodeURIComponent(search).substring(1).split('?');
                                    const currentSearch = currentPath.length > 1 ? '?' + currentPath[1] : '';
                                    return <Redirect to={{ pathname: currentPath[0], search: currentSearch }} />;
                                }} />
                                <Redirect to={{ pathname: "/errorpage", search: "?id=404" }} /> {/* اگر مسیر وجود نداشت به مسیر پیشفرض هدایت شود*/}
                            </Switch>

                            <BackTopButton />

                        </div>
                        {blockLayout && <div className="busy"><CustomSpinner title={blockTitle} /></div>}
                    </Content>
                </Layout>
                <Footer style={footerStyle}>
                    {Core.isTestEnvironment ?
                        <b>نسخه آزمایشی</b> :
                        <div>
                            <a href="https://si24.ir" target="_blank" rel="noreferrer">
                                <img src="/saman.png" style={{ height: 44 }} alt="شرکت بیمه سامان" ></img>
                                شرکت بیمه سامان
                            </a> ©2024
                        </div>
                    }
                </Footer>
            </Layout>
        );
    }
}
